var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file 面包屑
 * @author wangzhuang
 */

import React, { Component } from 'react';
import _ from 'lodash-es';

import BreadcrumbItem from './BreadcrumbItem';
import PropTypes from 'prop-types';
import { classPrefix } from '../../common/util';

/**
 * 参数说明
 * separator                可选，自定义分隔符，默认|
 * hint                     可选，双行样式的下方提示
 * classPrefix              可选，类名前缀
 */

var Breadcrumb = function (_Component) {
    _inherits(Breadcrumb, _Component);

    function Breadcrumb(props) {
        _classCallCheck(this, Breadcrumb);

        var _this = _possibleConstructorReturn(this, (Breadcrumb.__proto__ || Object.getPrototypeOf(Breadcrumb)).call(this, props));

        _this.state = {};
        return _this;
    }

    _createClass(Breadcrumb, [{
        key: 'renderCrumbs',
        value: function renderCrumbs() {
            var _props = this.props,
                children = _props.children,
                separator = _props.separator,
                classPrefix = _props.classPrefix;

            if (!children) {
                return '';
            }
            if (_.isArray(children)) {
                return React.createElement(
                    'div',
                    null,
                    children.filter(function (i) {
                        return i;
                    }) // 去除无效null等的项目
                    .map(function (item, index) {
                        return React.createElement(
                            BreadcrumbItem,
                            { separator: separator, key: index,
                                classPrefix: classPrefix
                            },
                            item.props.children
                        );
                    })
                );
            }
            return React.createElement(
                'div',
                null,
                React.createElement(
                    BreadcrumbItem,
                    { separator: separator, classPrefix: classPrefix },
                    children.props.children
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var hintItem = void 0;
            var _props2 = this.props,
                hint = _props2.hint,
                classPrefix = _props2.classPrefix;


            hint && (hintItem = React.createElement(
                'div',
                { className: classPrefix + '-breadcrumb-hint' },
                hint
            ));

            return React.createElement(
                'div',
                { className: classPrefix + '-breadcrumb' },
                this.renderCrumbs(),
                hintItem
            );
        }
    }]);

    return Breadcrumb;
}(Component);

export default Breadcrumb;


Breadcrumb.defaultProps = {
    classPrefix: classPrefix
};

Breadcrumb.propTypes = {
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    separator: PropTypes.node,
    hint: PropTypes.string,
    classPrefix: PropTypes.string
};